export default __webpack_public_path__ + "static/media/3_Moderate.b3dd87e2.png";